import { render, staticRenderFns } from "./ViewDemolitionsTable.vue?vue&type=template&id=8e8438b2"
import script from "./ViewDemolitionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDemolitionsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports